/**
 * GlobalSearch — search trigger shown in the app header.
 *
 * Navigates to the offline mail search (`/mail/search`). The template's
 * PowerSync-backed command palette (task/list search) was removed with the
 * todo domain.
 */

import { msg } from "@lingui/core/macro";
import { Search } from "@fleet/icons";
import { useI18n } from "@/providers/i18n-provider";
import { useNavigate } from "@tanstack/solid-router";

export function GlobalSearch() {
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <button
      type="button"
      id="global-search-trigger"
      data-testid="global-search-trigger"
      class="flex items-center gap-2 h-9 px-3 rounded-[10px] border border-border/50 bg-muted/40 text-muted-foreground cursor-pointer transition-all duration-150 ease-out max-w-[320px] min-w-[36px] hover:bg-muted/70 hover:border-border/80 hover:text-foreground"
      onClick={() => void navigate({ to: "/mail/search" })}
      aria-label={t(msg`Search mail`)}
    >
      <Search class="h-4 w-4 shrink-0 text-muted-foreground" />
      <span class="text-[13px] flex-1 text-left truncate tracking-[-0.01em] hidden sm:block">
        {t(msg`Search mail…`)}
      </span>
    </button>
  );
}
